import React from 'react';
import {
  Tooltip,
} from 'react-tippy';
import 'react-tippy/dist/tippy.css'

function createMarkup(a) { return {__html: a}; };

function NotesView(props) {
    return (
      <div>
        <h4>Notes
          <Tooltip
            theme="dark"
            interactive={true}
            position="bottom-start"
            trigger="click"
            arrow="true"
            size="regular"
            animateFill={true}
            html={(
             <pre style={{textAlign: 'left'}} dangerouslySetInnerHTML={{__html:props.legend}}></pre>
            )}
          >{` `}
          <span style={{color: 'red', cursor: 'pointer'}} className="glyphicon glyphicon-search preview" aria-hidden="true"></span>
          </Tooltip>
          </h4>
          <div dangerouslySetInnerHTML={createMarkup(props.data)} />
          </div>
    )
}
export default NotesView;



// WEBPACK FOOTER //
// ./src/components/itemscreens/NotesView.js